const topModal = (() => {

  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {



    const secMovieModal = document.querySelector('#jsSecMovieModal');
    const videos = secMovieModal.querySelectorAll('.js-video');

    MicroModal.init({
      disableScroll: true,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
      onShow: modal => {
        console.info(`${modal.id} is shown`)
        if (modal.id == 'modal-movie-1') {
          videos[0].play()
        }
        if (modal.id == 'modal-movie-2') {
          videos[1].play()
        }
        if (modal.id == 'modal-movie-3') {
          videos[2].play()
        }
        if (modal.id == 'modal-movie-4') {
          videos[3].play()
        }
        if (modal.id == 'modal-movie-5') {
          videos[4].play()
        }
        if (modal.id == 'modal-movie-6') {
          videos[5].play()
        }
      },
      onClose: modal => {
        console.info(`${modal.id} is hidden`)
        if (modal.id == 'modal-movie-1') {
          videos[0].pause()
        }
        if (modal.id == 'modal-movie-2') {
          videos[1].pause()
        }
        if (modal.id == 'modal-movie-3') {
          videos[2].pause()
        }
        if (modal.id == 'modal-movie-4') {
          videos[3].pause()
        }
        if (modal.id == 'modal-movie-5') {
          videos[4].pause()
        }
        if (modal.id == 'modal-movie-6') {
          videos[5].pause()
        }
      },
    });

    // MicroModal.show('modal-1');
  }


})()
export default topModal;